<script setup lang="ts">
const mediaQuery = useMediaQuery()

const props = defineProps<{
  score?: number
  reviews?: number
  routerLink?: string
  size?: 'small' | 'normal'
}>()

function openReviews() {
  navigateTo(props.routerLink)
}

const infoDialog = ref(null)
</script>

<template>
  <os-row
    class="os-stars"
    :class="{
      'os-stars--compact': !mediaQuery.isLarge || props.size === 'small',
    }"
    gap="narrow"
    :cross-axis-alignment="props.size === 'small' ? 'end' : 'center'"
    :main-axis-alignment="props.size === 'small' ? 'end' : 'center'"
    :wrap="true"
    v-if="score"
  >
    <div class="os-stars__value">
      <ion-icon :icon="ioniconsStarOutline" />
      <ion-icon :icon="ioniconsStarOutline" />
      <ion-icon :icon="ioniconsStarOutline" />
      <ion-icon :icon="ioniconsStarOutline" />
      <ion-icon :icon="ioniconsStarOutline" />

      <div
        class="os-stars__value__overlay"
        :style="'width: ' + ((score ?? 0) / 5) * 100 + '%'"
      >
        <ion-icon :icon="ioniconsStar" />
        <ion-icon :icon="ioniconsStar" />
        <ion-icon :icon="ioniconsStar" />
        <ion-icon :icon="ioniconsStar" />
        <ion-icon :icon="ioniconsStar" />
      </div>
    </div>

    <span class="os-stars__score">
      {{
        $n(Math.round((score ?? 0) * 10) / 10, 'decimal', $t('language.locale'))
      }}
      / 5
    </span>

    <ion-icon
      v-if="!reviews"
      slot="icon-only"
      :icon="ioniconsInformationCircleOutline"
      @click="infoDialog?.open()"
    ></ion-icon>

    <template v-if="reviews">
      <span>&nbsp;</span>

      <a v-if="routerLink" class="os-stars__counter" @click="openReviews()">
        {{ $t('stars.counter', { count: reviews }) }}
      </a>
    </template>

    <os-dialog ref="infoDialog" :title="$t('stars.info_title')">
      <div class="os-prose">
        <div v-html="$t('stars.info_text')"></div>
      </div>
    </os-dialog>
  </os-row>
</template>

<style scoped>
.os-stars {
  flex-grow: 0;
  flex-shrink: 0;
  white-space: nowrap;
}

.os-stars ion-icon {
  color: var(--green);
}

.os-stars .os-stars__value ion-icon,
.os-stars .os-stars__value__overlay ion-icon {
  font-size: 2rem;
}

.os-stars__value {
  position: relative;
  display: block;
  margin-top: 0;
}

.os-stars__value__overlay {
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  white-space: nowrap;
}

.os-stars__score {
  font-size: 1.1rem;
  vertical-align: middle;
  color: var(--header);
  margin-left: 1rem;
}

.os-stars__counter {
  font-size: 1rem;
  color: var(--header);
  opacity: 0.5;
  text-decoration: underline;
  cursor: pointer;
}

.os-stars--compact .os-stars__value ion-icon {
  font-size: 1.25rem;
}

.os-stars--compact .os-stars__score,
.os-stars--compact .os-stars__counter {
  font-size: 1rem;
  margin: 0;
}
</style>
